/** @jsxImportSource react */
import { cn } from '@common/lib/clsxm';
import FieldAdapter from '@react/form/components/FieldAdapter';
import { required } from '@react/form/helpers/validation';
import { Button } from '@react/system';
import React from 'react';
import { Field, Form } from 'react-final-form';

const CommonToolForm: React.FC<{
  handleSubmit: (values: any) => void;
  initialFilters: Record<string, any>;
  locationString?: string;
  nearest?: boolean;
  className?: string;
  buttonClassName?: string;
  buttonText?: string;
  eventProps?: Record<string, any>;
}> = ({
  handleSubmit,
  initialFilters,
  locationString = '',
  nearest = false,
  className = '',
  buttonClassName = '',
  buttonText = 'Calculate',
  eventProps = {},
}) => {
  return (
    <div className={cn('px-4 py-5', className)}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={handleSubmit}
        initialValues={initialFilters}
      >
        {({ handleSubmit, submitting, invalid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              data-tp-id='gen-form-2be9dba3-a4d6-4560-bb91-85d01e98c532'
            >
              <Field
                name='location'
                component={FieldAdapter}
                type='locationSearch'
                label='City name'
                data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                validate={required}
                types={['(cities)']}
                placeholder='Search by city'
                address={locationString}
              />
              {nearest && (
                <p className='mb-4 -mt-2 text-sm '>
                  The closest area for this data is:{' '}
                  <span>{locationString}</span>
                </p>
              )}
              <Button
                disabled={submitting || invalid}
                className={cn('w-full md:ml-auto md:w-max', buttonClassName)}
                data-tp-id='gen-Button-cb53f138-bb5f-4675-a94e-cf922c046697'
                eventProps={eventProps}
              >
                {buttonText}
              </Button>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

export default CommonToolForm;
